import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'headquarter-customers';

const getCustomerList = async ({
  companyHeadquarterId,
  page,
  limit,
  search,
  orderBy
}) => {
  const method = 'GET';
  const url =
    `${USE_CASE_URL}` +
    `?companyHeadquarterId=${companyHeadquarterId}&page=${page}&limit=${limit}&search=${search}&orderBy=${orderBy}`;

  const json = await request({ method, url });
  return json;
};

export default getCustomerList;
